import { render, staticRenderFns } from "./StorehouseAddNew.vue?vue&type=template&id=afce9d58&scoped=true&"
import script from "./StorehouseAddNew.vue?vue&type=script&lang=js&"
export * from "./StorehouseAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StorehouseAddNew.vue?vue&type=style&index=0&id=afce9d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afce9d58",
  null
  
)

export default component.exports